module.exports = __webpack_public_path__ + "img/account_mb_03.b1212e55.png";